import { Tabs } from 'finara-components';
import type { TabItem } from 'finara-components';
import { useState } from 'react';

import { Navbar } from '@/components/admin/general/Navbar';
import { adminNavItems } from '@/data/admin/general/navigationData';
import { useAuth } from '@/hooks/useAuth';
import {
  AdvanceDashboard,
  AdvanceRequests,
} from '@/pages/operaciones/adelantos-de-nomina/components';
import { PayrollAdvanceTab } from '@/types/credits';

export const AdelantosDeNominaPage: React.FC = () => {
  const { user } = useAuth();
  const [activeTab, setActiveTab] = useState<PayrollAdvanceTab>('solicitudes');

  // Get the organization ID from the user's context
  // For now, we'll use undefined until we have the proper user context structure
  // TODO: Update this when user context is properly defined with organization info
  const organizationId = undefined; // user?.organizationId or similar

  const tabs: TabItem[] = [
    { id: 'solicitudes', title: 'Solicitudes', onSelect: () => setActiveTab('solicitudes') },
    { id: 'dashboard', title: 'Dashboard', onSelect: () => setActiveTab('dashboard') },
  ];

  const renderTabContent = () => {
    switch (activeTab) {
      case 'dashboard':
        return <AdvanceDashboard organizationId={organizationId} />;
      case 'solicitudes':
        return <AdvanceRequests organizationId={organizationId} />;
      default:
        return <AdvanceDashboard organizationId={organizationId} />;
    }
  };

  return (
    <div className="min-h-screen">
      {/* Navbar */}
      <Navbar
        navItems={adminNavItems}
        userName={user?.name || 'Usuario'}
        pageTitle="Adelantos de Nómina"
        section="Nómina"
      />

      {/* Main Content */}
      <div className="px-4 py-8">
        {/* Page Header */}
        <div className="mb-8">
          <div className="lg:!flex items-center justify-between">
            <div className="mb-4 lg:!mb-0">
              <h1 className="text-2xl font-bold text-brand-white">Adelantos de Nómina</h1>
              <p className="text-muted mt-1">
                Sistema de financiamiento y adelantos para empleados
              </p>
            </div>
          </div>
        </div>

        {/* Tabs */}
        <div className="mb-6">
          <Tabs tabs={tabs} activeTabId={activeTab} />
        </div>

        {/* Tab Content */}
        {renderTabContent()}
      </div>
    </div>
  );
};
